document.addEventListener("DOMContentLoaded", function () {
  var isPortuguese = !window.location.pathname.startsWith('/en');
  if (!isPortuguese) return;

  function translateNewBadges() {
    document.querySelectorAll('.grid-product__tag--custom').forEach(function (badge) {
      var text = badge.textContent.trim().toUpperCase();

      if (text === 'NEW' || text === 'NOVO') {
        badge.textContent = 'NOVIDADE';
      }
    });
  }

  translateNewBadges();

  var observer = new MutationObserver(function () {
    translateNewBadges();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
